<template>
  <SummaryPanel title="Operation Mode" :badges="badges" :anchor-id="anchorId">
    <div class="panel-mini-row operation-mode-donuts">
      <div v-for="engine in donutEngines" :key="engine.key">
        <DonutChart
          :data="engine.items"
          label-key="label"
          value-key="raw"
          :colors="colors"
          :width="96"
          :height="96"
          :show-legend="false"
        />
        <div class="panel-caption">{{ engine.label }}</div>
      </div>
    </div>

    <div class="panel-table-scroll operation-mode-table">
      <table class="table panel-table">
        <thead class="thead-light">
          <tr>
            <th rowspan="2" class="operation-mode-mode-head">Mode</th>
            <th
              v-for="engine in model.engines"
              :key="engine.key"
              colspan="2"
              class="operation-mode-engine-head"
            >{{ engine.label }}</th>
          </tr>
          <tr>
            <template v-for="engine in model.engines">
              <th :key="`${engine.key}-share-head`">Share</th>
              <th :key="`${engine.key}-time-head`">Time</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(modeKey, index) in model.modeKeys" :key="modeKey">
            <td>
              <span class="operation-mode-swatch" :style="{ background: colors[index % colors.length] }"></span>
              {{ modeKey }}
            </td>
            <template v-for="engine in model.engines">
              <td :key="`${engine.key}-share`">{{ shareText(engine, modeKey) }}</td>
              <td :key="`${engine.key}-time`">{{ durationText(engine, modeKey) }}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </SummaryPanel>
</template>

<script>
import { formatNum } from '@/util/number';
import { toDuration } from '@/util/date';
import { OPERATION_MODE_PALETTE } from '@/util/designTokens';
import SummaryPanel from './SummaryPanel.vue';
import DonutChart from '../charts/DonutChart.vue';

export default {
  name: 'OperationModePanel',
  components: {
    SummaryPanel,
    DonutChart,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    badges: {
      type: Array,
      default: () => [],
    },
    anchorId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      colors: OPERATION_MODE_PALETTE,
    };
  },
  computed: {
    // warna per mode dikunci ke urutan modeKeys, bukan urutan data engine
    donutEngines() {
      return this.model.engines.map((engine) => ({
        key: engine.key,
        label: engine.label,
        items: this.model.modeKeys.map((modeKey) => {
          const mode = engine.modes.find((m) => m.key === modeKey);
          return { label: modeKey, raw: mode ? mode.seconds : 0 };
        }),
      })).filter((engine) => engine.items.some((item) => item.raw > 0));
    },
  },
  methods: {
    findMode(engine, modeKey) {
      return engine.modes.find((m) => m.key === modeKey) || null;
    },
    shareText(engine, modeKey) {
      const mode = this.findMode(engine, modeKey);
      return mode ? `${formatNum(mode.share, 1)}%` : '-';
    },
    durationText(engine, modeKey) {
      const mode = this.findMode(engine, modeKey);
      return mode ? toDuration(mode.seconds) : '-';
    },
  },
};
</script>

<style src="./summaryPanel.css"></style>

<style scoped>
.operation-mode-donuts {
  justify-content: center;
}

.operation-mode-table {
  margin-top: 8px;
}

/* first-child global bikin Share rata kiri, balikin */
.operation-mode-table thead tr + tr th:first-child {
  text-align: right;
}

.operation-mode-table th.operation-mode-engine-head {
  text-align: center;
}

.operation-mode-table th.operation-mode-mode-head {
  vertical-align: bottom;
}

.operation-mode-table td:first-child {
  text-transform: capitalize;
}

.operation-mode-swatch {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 4px;
}
</style>
